(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wldk-brand-bar"] && !Shopify.designMode) return;
  try {
    
class WldkBrandBar {
  constructor(el) {
    this.el = el;
    this.viewport = el.querySelector('.wldk-bb__viewport');
    this.marquee = el.querySelector('.wldk-bb__marquee');
    this.group = this.marquee ? this.marquee.querySelector('.wldk-bb__group') : null;
    this.lastWidth = 0;
    if (!this.marquee || !this.group) return;
    this.el.__wldkInit = true;
    this.bind();
    this.build();
  }

  reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  motionOn() {
    if (this.reducedMotion()) return false;
    const m = this.el.dataset.motion;
    if (m === 'always') return true;
    if (m === 'mobile') return window.matchMedia('(max-width: 749px)').matches;
    return false;
  }

  clearClones() {
    this.marquee.querySelectorAll('.wldk-bb__group--clone').forEach((n) => n.remove());
  }

  build() {
    this.clearClones();

    if (!this.motionOn()) {
      this.el.dataset.static = 'true';
      this.el.style.removeProperty('--wldk-shift');
      this.el.style.removeProperty('--wldk-duration');
      return;
    }

    const gapStr = getComputedStyle(this.marquee).columnGap || getComputedStyle(this.marquee).gap || '0';
    const gap = parseFloat(gapStr) || 0;
    const groupWidth = this.group.getBoundingClientRect().width;

    if (!groupWidth) {
      this.el.dataset.static = 'true';
      return;
    }

    const shift = groupWidth + gap;
    const needed = Math.max(2, Math.ceil((window.innerWidth * 2) / shift));

    for (let i = 1; i < needed; i++) {
      const clone = this.group.cloneNode(true);
      clone.classList.add('wldk-bb__group--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((a) => {
        a.setAttribute('tabindex', '-1');
        a.removeAttribute('title');
      });
      this.marquee.appendChild(clone);
    }

    const speed = parseFloat(this.el.dataset.speed) || 40;
    this.el.style.setProperty('--wldk-shift', shift + 'px');
    this.el.style.setProperty('--wldk-duration', (shift / speed).toFixed(3) + 's');
    this.el.dataset.static = 'false';
  }

  rebuild() {
    this.el.dataset.static = 'true';
    requestAnimationFrame(() => this.build());
  }

  bind() {
    this.lastWidth = window.innerWidth;

    let t;
    this._onResize = () => {
      if (window.innerWidth === this.lastWidth) return;
      this.lastWidth = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(() => this.rebuild(), 150);
    };
    window.addEventListener('resize', this._onResize);

    this.el.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => this.rebuild(), { once: true });
      }
    });

    if ('IntersectionObserver' in window) {
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          this.el.dataset.paused = e.isIntersecting ? 'false' : 'true';
        });
      });
      this._io.observe(this.el);
    }
  }

  destroy() {
    window.removeEventListener('resize', this._onResize);
    if (this._io) this._io.disconnect();
  }
}

(function () {
  function initAll(scope) {
    (scope || document).querySelectorAll('.wldk-bb').forEach(function (el) {
      if (!el.__wldkInit) new WldkBrandBar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.wldk-bb').forEach(function (el) {
      if (el.__wldkInit) return;
      new WldkBrandBar(el);
    });
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('shopify:block:select', function (e) {
    var bar = e.target.closest ? e.target.closest('.wldk-bb') : null;
    if (bar) bar.dataset.paused = 'true';
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var bar = e.target.closest ? e.target.closest('.wldk-bb') : null;
    if (bar) bar.dataset.paused = 'false';
  });
})();

  } catch(e) { console.error(e); }
})();
})();
